import { redirect } from "@sveltejs/kit";
import jwt from "jsonwebtoken";
import { p as prisma } from "./prisma.js";
import auth from "./auth.js";
import { b as SECRET_KEY, c as REFRESH_KEY } from "./private.js";
import { m as maxAge, s as secure } from "./utils2.js";
const handle = async ({ event, resolve }) => {
  const token = event.cookies.get("token");
  const refreshToken = event.cookies.get("refreshToken");
  let user = null;
  if (token) {
    try {
      const decoded = jwt.verify(token, SECRET_KEY);
      user = await prisma.user.findUnique({
        where: { id: decoded.id },
        include: { role: true }
      });
      if (!user?.refreshToken) {
        console.log("No refresh token in DB → invalid session.");
        event.cookies.delete("token", { path: "/" });
        event.cookies.delete("refreshToken", { path: "/" });
        user = null;
      }
    } catch (err) {
      if (err.name !== "TokenExpiredError") {
        console.warn("Invalid token:", err.message);
      }
    }
  }
  if (!user && refreshToken) {
    try {
      const decodedRefresh = jwt.verify(refreshToken, REFRESH_KEY);
      const userFromDB = await prisma.user.findUnique({
        where: { id: decodedRefresh.id }
      });
      if (userFromDB) {
        const isValid = await auth.verifyRefreshToken(refreshToken, userFromDB.id);
        if (isValid) {
          const newToken = auth.sign(userFromDB);
          event.cookies.set("token", newToken, {
            httpOnly: true,
            secure,
            path: "/",
            maxAge
          });
          user = userFromDB;
        } else {
          console.log("Invalid refresh token — clearing cookies.");
          event.cookies.delete("token", { path: "/" });
          event.cookies.delete("refreshToken", { path: "/" });
        }
      }
    } catch (err) {
      console.warn("Refresh token error:", err);
      event.cookies.delete("token", { path: "/" });
      event.cookies.delete("refreshToken", { path: "/" });
    }
  }
  if (user && token) {
    try {
      const decoded = jwt.verify(token, SECRET_KEY);
      const isSessionValid = await auth.verifySessionToken(decoded.sessionId, user.id);
      if (!isSessionValid) {
        console.log("Session conflict detected — invalidating session.");
        event.cookies.delete("token", { path: "/" });
        event.cookies.delete("refreshToken", { path: "/" });
        user = null;
      }
    } catch (err) {
      console.error("Session token verification error:", err);
      user = null;
    }
  }
  event.locals.user = user;
  if (user) {
    try {
      const now = /* @__PURE__ */ new Date();
      const sub = await prisma.userSubscription.findFirst({
        where: {
          userId: user.id,
          isActive: true,
          status: "ACTIVE",
          OR: [{ endsAt: null }, { endsAt: { gt: now } }]
        },
        orderBy: { endsAt: "desc" }
      });
      event.locals.subscription = sub || null;
      event.locals.isSubscribed = !!sub;
      console.log("hooks: subscription check", { userId: user.id, isSubscribed: event.locals.isSubscribed, subId: sub?.id ?? null });
    } catch (err) {
      console.error("hooks: subscription lookup error", err);
      event.locals.subscription = null;
      event.locals.isSubscribed = false;
    }
  } else {
    event.locals.subscription = null;
    event.locals.isSubscribed = false;
  }
  const protectedRoutes = ["/admin", "/subscription", "/legislation"];
  const isProtected = protectedRoutes.some((r) => event.url.pathname.startsWith(r));
  if (isProtected && !user) {
    throw redirect(303, "/login");
  }
  return await resolve(event);
};
export {
  handle
};
